import React, { memo } from 'react';
import CloudWatchDashboard from './CloudWatchDashboard';
import { getRabbitQueuesMetrics } from './metrics/rabbitQueuesMetrics';
import { Broker, EC2Instance } from '@amzn/amazonmq-opsconsole-client';

type Props = {
    broker: Broker,
    brokerInstances: EC2Instance[]
}

const RabbitQueuesTab : React.FC<Props> = ({broker, brokerInstances}) => {
    let widgets = getRabbitQueuesMetrics(broker, brokerInstances);

    return (
        <div>
            <CloudWatchDashboard
                broker={broker}
                layoutType='manual'
                widgetsPerRow={2}
                serviceAccountId={broker.summary.serviceAccountId}
                widgets={widgets}
            /> 
        </div>
    )
}

export default memo(RabbitQueuesTab);